
import { Component, Vue, Watch} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';
import {
	employeeList,
    dataAnalysischoseMemberBox,
	employeeOperatorConfigSave,
	employeeOperatorConfigInfo
} from '@/api/toBApi';

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		'slz-dialog': Dialog,
		'slz-message': Message,
	}
})
export default class EmployeeAccountEdit extends Vue {

	private formData: any = {
		EmployeeId: null,
		roleFirstType: null,
		roleSecondType: null,
	}
	private rules: any = {
		EmployeeId: [
			{ required: true, message: '请选择员工', trigger: 'change' }
		]
	}
	private employeeList: any = [];

	private infoId = '';
	private pageLoading = false;

	private showDialog = false;
	private pageNo = 1;
	private pageSize = 10;
	private roleGrade = 0;
	private keywords = '';
	private loading = false;
	private list = [];
	private total = 0;
	private selectionList = [];
	

	private firstSelectData = {
		list: [],
		keywords: '',
		searchKeywords: '',
		pageNo: 1,
		pageSize: 10,
		total: 0
	}
	private secondSelectData = {
		list: [],
		keywords: '',
		searchKeywords: '',
		pageNo: 1,
		pageSize: 10,
		total: 0
	}

	get firstData(){
		const { pageNo, pageSize, searchKeywords, list } = this.firstSelectData;
		let array = [];
		let keywords = searchKeywords.trim();
		if (keywords === ''){
			array = list;
		}else{
			array = list.filter(item=>{
				const {Id, Name, Phone} = item;
				let phoneLastNum = Phone.substr(Phone.length-4, 4);
				return (Id+'').indexOf(keywords) > -1 || Name.indexOf(keywords) > -1 || phoneLastNum.indexOf(keywords) > -1;
			})
		}

		let start = (pageNo-1) * pageSize;
		let end = start + pageSize;
		this.firstSelectData.total = array.length;
		return array.slice(start, end);
	}
	get secondData(){
		const { pageNo, pageSize, searchKeywords, list } = this.secondSelectData;
		let array = [];
		let keywords = searchKeywords.trim();
		if (keywords === ''){
			array = list;
		}else{
			array = list.filter(item=>{
				const {Id, Name, Phone} = item;
				let phoneLastNum = Phone.substr(Phone.length-4, 4);
				return (Id+'').indexOf(keywords) > -1 || Name.indexOf(keywords) > -1 || phoneLastNum.indexOf(keywords) > -1;
			})
		}
		
		let start = (pageNo-1) * pageSize;
		let end = start + pageSize;
		this.secondSelectData.total = array.length;
		return array.slice(start, end);
	}

	private mounted() {
		const route: any = this.$route;
		if (route.query.id){
			this.infoId = route.query.id;
			this.getDetails();
		}
		this.getEmployeeList();
	}

	private navBack(){
		this.$router.replace({
			name: 'employeeAccount'
		})
	}
	private handleKeyUp(e, key){
		if (e.keyCode === 13){
			this[key].pageNo = 1;
			this[key].searchKeywords = this[key].keywords;
		}
	}
	private async getDetails(){
		this.pageLoading = true;
		try {
			const res: any = await employeeOperatorConfigInfo({Id: this.infoId});
			const {
				EmployeeId,
				FistRoleVisibleType,
				SecondRoleVisibleType,
				FirstChoseMemberList,
				SecondChoseMemberList,
			} = res.Result;

			this.formData.EmployeeId = EmployeeId;
			this.formData.roleFirstType = [3,1,2][FistRoleVisibleType];
			this.formData.roleSecondType = [3,1,2][SecondRoleVisibleType];
			this.firstSelectData.list = FirstChoseMemberList.map(item=>{
				item.Id = item.MemberId;
				return item;
			});
			this.secondSelectData.list = SecondChoseMemberList.map(item=>{
				item.Id = item.MemberId;
				return item;
			});;

		} catch (err) { 

		} finally {
			this.pageLoading = false;
		}
	}

	private async getEmployeeList() {
		try {
			const res: any = await employeeList({});
			this.employeeList = res.Result.map(item => {
				item.value = `${item.EmployeeName}(${item.Phone})`;
				return item;
			});
		} catch (err) { }
	}

	private selectDataPage(e, key) {
		this[key].pageNo = e;
	}

	private handleDeleteItem(record, key){
		let list = this[key].list.filter(item=>{
			return item.Id !== record.Id;
		})
		this[key].list = list;
	}

	//选择代理
	private handleSearch() {
		this.pageNo = 1;
		this.getAgentList();
	}
	private changePage(e) {
		this.pageNo = e
		this.getAgentList();
	}
	private selectionChange(selection) {
		this.selectionList = selection;
	}
	private handleCancel() {
		this.showDialog = false;
	}
	private handleSure() {
		if (!this.selectionList.length) {
			this.$message({
				type: 'warning',
				message: '请选择分销员'
			})
			return;
		}
		if (this.roleGrade === 1) {
			this.firstSelectData.list = this.selectionList;
		} else {
			this.secondSelectData.list = this.selectionList;
		}
		this.handleCancel();
	}
	private selectAgent(e, type) {
		this.pageNo = 1;
		this.roleGrade = type === 'roleFirstType' ? 1 : 2;
		this.showDialog = true;
		

		this.$nextTick(()=>{
			const ref: any = this.$refs['popTable'];
			
			let list = []
			if (this.roleGrade === 1) {
				list = this.firstSelectData.list;
			} else {
				list = this.secondSelectData.list;
			}
			this.selectionList = list;
			if (list.length){
				console.log(list,'list')
				this.$nextTick(()=>{
					list.map(item=>{
						ref.toggleRowSelection(item, true)
					})
				})
				
			}

			this.getAgentList();
		})

		
	}
	private async getAgentList() {
		let params: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			RoleGrade: this.roleGrade,
			Keywords: this.keywords.trim(),
		}

		try {
			this.loading = true;
			const res: any = await dataAnalysischoseMemberBox(params)
			this.list = res.Result.Results.map(item=>{
				item.RoleGradeValue = this.roleGrade === 1 ? '联创':'核心';
				item.RoleGrade = this.roleGrade;
				return item;
			});
			this.total = res.Result.Total;
		} catch (e) {
			console.log(e)
		} finally {
			this.loading = false;
		}
	}

	private handleSave() {
		let ref: any = this.$refs['form'];
		ref.validate((valid) => {
			if (valid) {
				if ((this.formData.roleFirstType === null || this.formData.roleFirstType === 3) && (this.formData.roleSecondType === null || this.formData.roleSecondType === 3)){
					this.$message.error('请配置可视团队')
					return;
				}
				if (this.formData.roleFirstType === 2 && !this.firstSelectData.list.length){
					this.$message.error('请选择指定联创')
					return;
				}
				if (this.formData.roleSecondType === 2 && !this.secondSelectData.list.length){
					this.$message.error('请选择指定核心')
					return;
				}

				this.save();
			} else {
				return false;
			}
		});
	}
	private async save(){
		if (this.pageLoading) return;
		this.pageLoading = true;
		try {

			const dt = this.employeeList.filter(item=>{
				return item.Id === this.formData.EmployeeId;
			})

			const res: any = await employeeOperatorConfigSave({
				Id: this.infoId,
				EmployeeId: dt[0].Id,
				EmployeeName: dt[0].EmployeeName,
				Phone: dt[0].Phone,
				FistRoleVisibleType: ['',1,2,0][this.formData.roleFirstType],
				FirstChoseMemberIdList: this.firstSelectData.list.map(item=>{
					return item.Id
				}),
				SecondRoleVisibleType: ['',1,2,0][this.formData.roleSecondType],
				SecondChoseMemberIdList: this.secondSelectData.list.map(item=>{
					return item.Id
				}),
			});
			
			this.$message.success('操作成功');
			this.$router.replace({
				name: 'employeeAccount'
			})

		} catch (err) { 

		} finally {
			setTimeout(()=>{
				this.pageLoading = false;
			}, 1000)
		}
	}

}
